module.exports = __webpack_public_path__ + "img/modal-reference.59f928e0.png";